var render, staticRenderFns
import script from "./JeepayTableColumns.vue?vue&type=script&lang=js"
export * from "./JeepayTableColumns.vue?vue&type=script&lang=js"
import style0 from "./JeepayTableColumns.vue?vue&type=style&index=0&id=5af6b31f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af6b31f",
  null
  
)

export default component.exports